const Checkmark = ({
  color = '#345251',
  className,
  size = '24',
}: {
  color?: string;
  size?: string;
  className?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`inline ${className}`}
    >
      <path
        d="M13.8606 0.458984C6.6831 0.458984 0.84375 6.29833 0.84375 13.4758C0.84375 20.6533 6.6831 26.4926 13.8606 26.4926C21.0381 26.4926 26.8774 20.6533 26.8774 13.4758C26.8774 6.29833 21.0381 0.458984 13.8606 0.458984ZM11.2585 19.2201L6.42537 14.3974L8.26334 12.5542L11.2559 15.5416L18.147 8.65048L19.9876 10.4911L11.2585 19.2201Z"
        fill={color}
      />
    </svg>
  );
};

export default Checkmark;
